// Pure helpers for SearchableChoiceSelect.vue, extracted so the dropdown's
// core logic (search-field threshold, substring filtering, disabled-skipping
// navigation) is unit-testable without mounting the component.

/**
 * The in-dropdown search field only earns its place once the list is long
 * enough to scroll. `maxVisibleOptions` mirrors the number of rows visible
 * before the options list (`max-height`) starts scrolling.
 *
 * @param {Array} choices
 * @param {number} maxVisibleOptions
 * @returns {boolean}
 */
export function shouldShowSearch(choices, maxVisibleOptions) {
  return (choices?.length || 0) > maxVisibleOptions;
}

/**
 * Pure, local, case-insensitive substring filter over a choice's `content` and
 * `description`. An empty or whitespace-only query returns the list unchanged
 * (same reference), and the original order is preserved.
 *
 * @param {Array} choices
 * @param {string} query
 * @returns {Array}
 */
export function filterChoices(choices, query) {
  const list = choices || [];
  const q = (query || '').trim().toLowerCase();
  if (!q) return list;
  return list.filter(
    (choice) =>
      (choice.content || '').toLowerCase().includes(q) ||
      (choice.description && choice.description.toLowerCase().includes(q))
  );
}
